"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _panel = _interopRequireDefault(require("../../control-components/panel"));

var Robots = function Robots(props) {
  return (0, _preact.h)("div", null, (0, _preact.h)(_panel.default, {
    title: "Details"
  }, (0, _preact.h)("textarea", {
    className: "form-control",
    onKeyUp: function onKeyUp(e) {
      return props.onChange(e.target.value.trim());
    },
    rows: "16"
  }, props.data)));
};

var _default = Robots;
exports.default = _default;